<template>
  <div id="main-content" class="add-place">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row>
          <el-col :span="12" style="display: inline">
            <el-col :span="8"><span class="required-star">* </span><span class="form-lable">{{ $t('common.category') }}</span></el-col>
            <input class="input" v-model="bus_notification_category_data.name" type=""/>
          </el-col>
        </el-row>

        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "AddBusNotificationCategory",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/bus-notification-template/category`,
        title: 'common.add_category',
        bus_notification_category_data: {
          name: ""
        },
      }
    },
    methods: {
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push('/bus-notification-template/category')
          };
          let payload = {
            successCallback,
            data: this.bus_notification_category_data
          }

          this.$store.dispatch('busnotificationtemplate/createBusNotificationCategory', payload);
        }
      },
      validate: function () {
        if (this.bus_notification_category_data.name == "") {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.name_is_required')
          })
          return false
        }
        return true
      },
    },
  }
</script>

<style lang="scss">
</style>